import React from 'react';
import { componentService } from 'js/services/component.service';

export const InactivityTimeout = React.lazy(() => import(/* webpackChunkName: "inactivity-timeout" */ './InactivityTimeout'));

componentService.registerPageComponents({ 'inactivity-timeout': InactivityTimeout });
